/* esm.sh - applesauce-common@5.2.0/dist/operations/reaction */
export * from "/*applesauce-common@5.2.0/esnext/dist/operations/reaction.mjs";
